<div class="view-container">
    <mat-card>
        <mat-card-content>
            <product-catalog-list
                [companyIdFilter]="companyIdFilter"
                [productTypeFilter]="productTypeFilter"
                [productStateFilter]="productStateFilter"
                [rangeIdFilter]="productRangeFilter"
                [searchTerm]="searchTerm"
                (onFilterCompanyId)="onFilterCompanyId($event)"
                (onFilterProductTypeId)="onFilterProductTypeId($event)"
                (onFilterProductState)="onFilterProductState($event)"
                (onFilterProductRangeId)="onFilterProductRange($event)"
                (onProductSelected)="onProductSelected($event)"
                (onSearchTermChanged)="onSearchTermChanged($event)"
                [isCatalog]="true">
            </product-catalog-list>
        </mat-card-content>
    </mat-card>
</div>

  